import lax from 'lax.js'
document.addEventListener('DOMContentLoaded', () => {
  const catalog = document.querySelector('.catalog')
  const catalogBack = catalog?.querySelector('.catalog__back')

  if (catalog && catalogBack) {
    lax.init()

    lax.addDriver('scrollY', function () {
      return window.scrollY
    })

    let timeout



    const createParallax = () => {
      if(catalogBack.clientHeight === 0 ) {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          createParallax()
        }, 200)
        return
      }
      lax.removeElement('.catalog__back')
      lax.addElements('.catalog__back', {
        scrollY: {
          translateY: [
            ["elInY", "elOutY"],
            [(catalogBack.clientHeight - catalog.clientHeight) / 2 * -1, (catalogBack.clientHeight - catalog.clientHeight) / 2] ,
          ]
        }
      })
    }

    window.addEventListener('resize', createParallax)

    createParallax()

    // let moveCoef = 0.5;
    //
    // const scroll = () => {
    //   let maxHeight = catalogBack.clientHeight - catalog.clientHeight
    //   let minHeight = catalog.clientHeight - catalogBack.clientHeight
    //   /* берём огнаничивающий прямоугольник паралакса относительно окна (фрейма) */
    //   let r = catalogBack.getBoundingClientRect();
    //
    //   /* центр паралакса */
    //   let paralaxYCenter = r.y + r.height / 2;
    //   /* центр экрана */
    //   let scrollYCenter = window.innerHeight / 2;
    //
    //   /* Вычисляем смещение */
    //   let move = (paralaxYCenter - scrollYCenter) * moveCoef - 100;
    //
    //
    //   if(move > maxHeight) move = maxHeight
    //   if(move < minHeight) move = minHeight
    //   if(move <= -40 && window.innerWidth < 780) {
    //     move = -40
    //   }
    //
    //
    //
    //   catalogBack.style.bottom = move + "px";
    // }
    //
    // window.addEventListener("scroll", scroll);
    // window.addEventListener("resize", scroll);
    // scroll();


    // const differenceHeight = catalogBack.clientHeight - catalogHeight
    // let scrollTop = 0
    // window.addEventListener('scroll', (e) => {

      // const differenceScroll = window.scrollY - catalog.offsetTop
      // let top
      // if(window.scrollY > scrollTop) {
      //   top = '0'
      // }else {
      //   top = '100%'
      // }
      //
      //
      //
      // catalogBack.style.top =  top
      // scrollTop = window.scrollY
      //
      // if(top > catalogBack.clientHeight - catalogHeight ) top = catalogHeight

  }

})